import he from "he";
import { client } from "./client";
import type { SnipeItLocation } from "./types";

export async function fetchLocationById(id: number): Promise<SnipeItLocation> {
  const res = await client.get<SnipeItLocation>(`/api/v1/locations/${id}`);
  return { ...res.data, name: he.decode(res.data.name) };
}

export async function searchLocations(query: string): Promise<SnipeItLocation[]> {
  if (!query) return [];
  const res = await client.get<{ rows: SnipeItLocation[] }>("/api/v1/locations", {
    params: { search: query, limit: 20 },
  });
  return (res.data.rows ?? []).map((location) => ({ ...location, name: he.decode(location.name) }));
}
